/**
 * LMTM 商品詳細
 *  - バリエーションカードの選択 → フォームの id / 価格 / ボタン状態 / 画像 / URL を更新
 *  - 在庫なし かつ 再入荷タグありのとき、カート行を再入荷リクエストに差し替える
 *  - サムネイルの切替と左右送り
 *  - リンクのコピー
 *
 * お気に入り・再入荷の送信自体は ganymede-wishlist.js / ganymede-restock.js が担当する。
 * 両者は .product-variant-id の change を見て data-variant-id を追従するので、
 * ここでは hidden input を更新して change を発火させるだけでよい。
 */
(function () {
  'use strict';

  function initGallery(root) {
    var gallery = root.querySelector('[data-lmtm-gallery]');
    if (!gallery) return null;

    var main = gallery.querySelector('[data-lmtm-gallery-main]');
    var incoming = gallery.querySelector('[data-lmtm-gallery-incoming]');
    var stageBox = gallery.querySelector('[data-lmtm-gallery-stage]');
    var track = gallery.querySelector('[data-lmtm-gallery-track]');
    var thumbs = [].slice.call(gallery.querySelectorAll('[data-lmtm-gallery-thumb]'));

    /* ⚠️ scrollIntoView はサムネ列（scroll-snap ＋ overflow-x）だと動かないことがある。
       枠からはみ出したぶんだけ自分でスクロールさせる。 */
    function reveal(el) {
      if (!track || !el) return;
      var t = track.getBoundingClientRect();
      var b = el.getBoundingClientRect();
      var delta = 0;
      if (b.left < t.left) delta = b.left - t.left;
      else if (b.right > t.right) delta = b.right - t.right;
      if (!delta) return;
      if (track.scrollTo) track.scrollTo({ left: track.scrollLeft + delta, behavior: 'smooth' });
      else track.scrollLeft += delta;
    }

    /* ===== メイン画像の切り替え =====
       手前（main）と奥（incoming）の2枚を重ねてあり、両方を同時に横へ動かす。
       dir が +1 なら「次へ」＝ 新しい画像が右から入ってくる。
       dir を渡さない（0）ときはアニメーションなしで差し替える。

       ⚠️ 画像を1枚だけ差し替える作りだと、どうしても「ぱっと変わる」動きになる。
       ⚠️ 端から端へ回るときも dir を見て動かすので、途中の画像を通過しない。 */
    var sliding = false;
    var reduceQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function setImage(img, thumb) {
      img.removeAttribute('srcset');
      img.src = thumb.getAttribute('data-full');
      img.alt = thumb.getAttribute('data-alt') || '';
    }

    function markActive(thumb) {
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    }

    /* 走っている途中のアニメーションは、次を始める前に終わらせてしまう */
    function settle() {
      if (!sliding) return;
      sliding = false;
      stageBox.classList.remove('is-sliding');
      stageBox.classList.remove('is-fading');
      main.style.transition = '';
      incoming.style.transition = '';
      main.style.transform = '';
      incoming.style.transform = '';
      incoming.style.opacity = '';
      if (incoming.src) {
        main.removeAttribute('srcset');
        main.src = incoming.src;
        main.alt = incoming.alt;
      }
    }

    /* ⚠️ スライドで見せるのは原寸（1200px）のほう。読み込み前だと
       白いまま滑ってきて「動いていない」ように見えるので、隣の2枚を先に温めておく。 */
    var warmed = {};
    function warm(i) {
      var t = thumbs[i];
      if (!t) return;
      var url = t.getAttribute('data-full');
      if (!url || warmed[url]) return;
      warmed[url] = true;
      var pre = new Image();
      pre.src = url;
    }

    function warmNeighbours(i) {
      var n = thumbs.length;
      if (n < 2) return;
      warm((i + 1) % n);
      warm((i - 1 + n) % n);
    }

    function activate(thumb, dir) {
      if (!thumb || !main) return;
      settle();
      markActive(thumb);
      warmNeighbours(thumbs.indexOf(thumb));

      if (!dir || !incoming || !stageBox) {
        setImage(main, thumb);
        return;
      }

      setImage(incoming, thumb);
      incoming.alt = '';

      /* 「視差効果を減らす」設定のときは横に動かさず、短いフェードにする */
      var soft = !!(reduceQuery && reduceQuery.matches);

      /* 始点を確定させてから transition を戻したいので、一度レイアウトを読む */
      stageBox.classList.add(soft ? 'is-fading' : 'is-sliding');
      incoming.style.transition = 'none';
      if (soft) {
        incoming.style.opacity = '0';
      } else {
        incoming.style.transform = 'translateX(' + dir * 100 + '%)';
      }
      void incoming.offsetWidth;
      incoming.style.transition = '';

      sliding = true;
      if (soft) {
        incoming.style.opacity = '1';
      } else {
        main.style.transform = 'translateX(' + dir * -100 + '%)';
        incoming.style.transform = 'translateX(0)';
      }

      var done = function (event) {
        if (event && event.target !== incoming) return;
        incoming.removeEventListener('transitionend', done);
        clearTimeout(timer);
        settle();
      };
      /* transitionend が来ないケース（タブが裏など）に備えて保険を掛ける */
      var timer = setTimeout(done, 600);
      incoming.addEventListener('transitionend', done);
    }

    /* 最初に表示している画像の隣も温めておく */
    if (thumbs.length > 1) {
      var first = 0;
      for (var wi = 0; wi < thumbs.length; wi++) {
        if (thumbs[wi].classList.contains('is-active')) first = wi;
      }
      setTimeout(function () { warmNeighbours(first); }, 400);
    }

    function activeIndexOf() {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var from = activeIndexOf();
        var to = thumbs.indexOf(thumb);
        activate(thumb, from === to ? 0 : to > from ? 1 : -1);
      });
    });

    /* メイン画像を左右に払って送る。端まで行ったら反対の端へ回る。

       ⚠️ pointerup を待って判定すると、途中でブラウザにジェスチャを取られて
       pointercancel になった場合にスワイプが消える（iOS で起きやすい）。
       **閾値を超えた時点で送ってしまう**ことで取りこぼさないようにしている。
       マウスのドラッグでも動く。画像そのもののドラッグは止める。 */
    var stage = gallery.querySelector('[data-lmtm-gallery-stage]');
    if (stage && thumbs.length > 1) {
      var swipeFrom = null;
      var SWIPE_MIN = 40;

      function shift(dir) {
        var i = (activeIndexOf() + dir + thumbs.length) % thumbs.length;
        activate(thumbs[i], dir);
        reveal(thumbs[i]);
      }

      stage.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });

      stage.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        swipeFrom = { x: event.clientX, y: event.clientY };
      });

      stage.addEventListener('pointermove', function (event) {
        if (!swipeFrom) return;
        var dx = event.clientX - swipeFrom.x;
        var dy = event.clientY - swipeFrom.y;
        /* 縦スクロールと取り違えないよう、横の動きが縦より大きいときだけ */
        if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) <= Math.abs(dy)) return;
        swipeFrom = null;
        shift(dx < 0 ? 1 : -1);
      });

      stage.addEventListener('pointerup', function () { swipeFrom = null; });
      stage.addEventListener('pointercancel', function () { swipeFrom = null; });
      stage.addEventListener('pointerleave', function () { swipeFrom = null; });
    }

    if (track) {
      var prev = gallery.querySelector('[data-lmtm-gallery-prev]');
      var next = gallery.querySelector('[data-lmtm-gallery-next]');

      /* ⚠️ 送り幅は「サムネ幅 ＋ 実際の隙間」。決め打ちにすると1回ごとにズレていき、
         数回送ったところでサムネが枠から半分はみ出す。はみ出した部分は
         overflow でクリップされていてクリックが当たらない（＝押しても反応しない）。
         隙間は CSS を変えても追従するよう、li の位置差から測る。 */
      function pitch() {
        var items = track.querySelectorAll('li');
        if (items.length > 1) {
          var d = items[1].offsetLeft - items[0].offsetLeft;
          if (d > 0) return d;
        }
        return items.length ? items[0].offsetWidth : 100;
      }

      function perPage(p) {
        return Math.max(1, Math.round(track.clientWidth / p));
      }

      function maxIndex(p) {
        return Math.max(0, track.querySelectorAll('li').length - perPage(p));
      }

      /* ⚠️ スムーススクロールの途中の scrollLeft を足し算の元にすると、
         連打したぶんだけ位置がずれる。何枚目まで送ったかを自分で持っておく。 */
      var index = 0;

      function syncArrows() {
        if (!prev || !next) return;
        var p = pitch();
        prev.disabled = index <= 0;
        next.disabled = index >= maxIndex(p);
      }

      /* 送りは1枚ずつ（元の挙動のまま）。端は「最後の1枚が右端に来る位置」で止める */
      function go(dir) {
        var p = pitch();
        index = Math.min(Math.max(index + dir, 0), maxIndex(p));
        if (track.scrollTo) {
          track.scrollTo({ left: index * p, behavior: 'smooth' });
        } else {
          track.scrollLeft = index * p;
        }
        syncArrows();
      }

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });

      /* 指やトラックパッドで直接動かされたときは、落ち着いてから index を取り直す */
      var settle;
      track.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(function () {
          var p = pitch();
          index = Math.min(Math.round(track.scrollLeft / p), maxIndex(p));
          syncArrows();
        }, 120);
      });

      window.addEventListener('resize', function () {
        var p = pitch();
        index = Math.min(index, maxIndex(p));
        syncArrows();
      });

      syncArrows();
    }

    return {
      // バリエーションに紐づく画像があればそれに切り替える
      showMedia: function (mediaId, fullUrl) {
        if (!mediaId) return;
        var match = thumbs.filter(function (t) {
          return t.getAttribute('data-media-id') === String(mediaId);
        })[0];
        if (match) {
          activate(match, 0);
          reveal(match);
        } else if (main && fullUrl) {
          main.removeAttribute('srcset');
          main.src = fullUrl;
        }
      },
    };
  }

  function initVariants(root, gallery) {
    var inputs = [].slice.call(root.querySelectorAll('.lmtm-variant__input'));
    if (inputs.length === 0) return;

    var hidden = root.querySelector('.product-variant-id');
    var qtySelect = root.querySelector('.lmtm-qty__select');
    var buyRow = root.querySelector('[data-lmtm-buy]');
    var submit = root.querySelector('[data-lmtm-submit]');
    var submitLabel = root.querySelector('[data-lmtm-submit-label]');
    var restock = root.querySelector('[data-lmtm-restock]');
    var restockEnabled = root.getAttribute('data-restock-enabled') === 'true';
    // 発売前（COMING SOON）。これが true のあいだは在庫があっても買わせない（C-15）
    var beforeSale = root.getAttribute('data-before-sale') === 'true';
    var soldOutLabel = (submitLabel && submitLabel.getAttribute('data-sold-out')) || null;
    var comingSoonLabel = (submitLabel && submitLabel.getAttribute('data-coming-soon')) || null;

    // 数量の上限はバリエーションごとに違う（custom.max_quantity）。
    // プルダウンはサーバー側で1回しか描かれないので、切り替えのたびに作り直す。
    // いま選んでいる数が新しい上限を超えるときは上限まで下げる。
    function applyQtyMax(input) {
      if (!qtySelect) return;
      var max = parseInt(input.getAttribute('data-max-qty'), 10);
      if (!max || max < 1) return;
      if (qtySelect.options.length === max) return;

      var wanted = parseInt(qtySelect.value, 10) || 1;
      var keep = Math.min(wanted, max);
      var out = '';
      for (var i = 1; i <= max; i += 1) {
        out += '<option value="' + i + '"' + (i === keep ? ' selected' : '') + '>' + i + '</option>';
      }
      qtySelect.innerHTML = out;
      qtySelect.value = String(keep);
    }

    function apply(input) {
      var available = input.getAttribute('data-available') === 'true';
      // 在庫があっても発売前なら買えない
      var buyable = available && !beforeSale;

      applyQtyMax(input);

      if (hidden) {
        hidden.value = input.value;
        hidden.disabled = !available;
        // ganymede-wishlist.js / ganymede-restock.js がこの change を見ている
        hidden.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (submit) {
        submit.disabled = !buyable;
      }
      if (submitLabel) {
        if (beforeSale && comingSoonLabel) {
          submitLabel.textContent = comingSoonLabel;
        } else if (soldOutLabel) {
          submitLabel.textContent = available ? submitLabel.dataset.addLabel : soldOutLabel;
        }
      }

      // 在庫なし＋再入荷タグ → カート行を再入荷リクエストに差し替え
      if (restockEnabled && restock) {
        restock.hidden = available;
        if (buyRow) buyRow.hidden = !available;
      }

      if (gallery) {
        gallery.showMedia(input.getAttribute('data-media-id'), input.getAttribute('data-media-full'));
      }

      // 共有・リロード用に URL のバリエーションを合わせる
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (submitLabel && !submitLabel.dataset.addLabel) {
      // Liquid が data-add-label を持たせているときはそちらを使う。
      // ⚠️ 初期表示の文字から拾うと、最初が SOLD OUT / COMING SOON の商品で
      //    その文字を「カートに入れる」として覚えてしまう。
      submitLabel.dataset.addLabel = submitLabel.textContent.trim();
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) apply(input);
      });
    });
  }

  function initCopyLink(root) {
    root.querySelectorAll('[data-lmtm-copy-link]').forEach(function (button) {
      button.addEventListener('click', async function () {
        var url = button.getAttribute('data-url');
        if (!url) return;
        try {
          await navigator.clipboard.writeText(url);
        } catch (err) {
          var field = document.createElement('input');
          field.value = url;
          document.body.appendChild(field);
          field.select();
          document.execCommand('copy');
          document.body.removeChild(field);
        }
        var feedback = root.querySelector('[data-wishlist-feedback]');
        if (feedback) {
          feedback.textContent = button.getAttribute('data-copied') || '';
          feedback.hidden = false;
          clearTimeout(feedback._timer);
          feedback._timer = setTimeout(function () {
            feedback.hidden = true;
          }, 4000);
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-lmtm-product]').forEach(function (root) {
      var gallery = initGallery(root);
      initVariants(root, gallery);
      initCopyLink(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
